export default __webpack_public_path__ + "static/media/2_0048.cccb8138.webp";